import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./popularproducts.css";

import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import StarIcon from "@mui/icons-material/Star";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import IconOne from "../../assets/images/category-1.svg";
import Watermark from "../../assets/images/no_product.jpg";

import { WishlistContext } from "../../context/WishlistContext";
import { CartContext } from "../../context/CartContext";
import { baseURL } from "../../constants/url";
import Swal from "sweetalert2";

function PopularProducts() {
  const [products, setProducts] = useState([]);
  const { fetchWishlistCount } = useContext(WishlistContext);
  const { cartItems, fetchCartCount } = useContext(CartContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${baseURL}common/products/`);
      const data = res.data.results || res.data;

      const formatted = data.map((product) => ({
        ...product,
        variants: product.variants || [],
      }));

      setProducts(formatted);
    } catch (error) {
      console.error("Product fetch error:", error);
    }
  };

  // ================= ADD TO CART =================
  const addToCart = async (variant) => {
  if (variant.stock === 0) return;

  const token = localStorage.getItem("authToken");

  if (!token) {
    Swal.fire({
      icon: "warning",
      title: "Login Required",
      text: "Please login first",
      confirmButtonText: "Go to Login",
    }).then(() => {
      navigate("/login");
    });
    return;
  }

    const alreadyInCart = cartItems?.some(
      (item) => item.variant_id === variant.id
    );

    if (alreadyInCart) {
      Swal.fire("Already Added", "Product already in cart", "info");
      return;
    }

    try {
      await axios.post(
        `${baseURL}common/cart/add/`,
        { variant_id: variant.id, quantity: 1 },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Swal.fire({
        icon: "success",
        title: "Added to Cart",
        timer: 1200,
        showConfirmButton: false,
      });

      fetchCartCount();
    } catch (error) {
      Swal.fire("Error", "Failed to add to cart", "error");
    }
  };

  // ================= WISHLIST =================
  const toggleWishlist = async (variantId) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const res = await axios.post(
        `${baseURL}common/wishlist_toggle/${variantId}/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const isAdded = res.data?.message?.toLowerCase().includes("added");

      setProducts((prev) =>
        prev.map((p) => ({
          ...p,
          variants: p.variants.map((v) =>
            v.id === variantId ? { ...v, is_wishlisted: isAdded } : v
          ),
        }))
      );

      fetchWishlistCount();
    } catch (error) {
      Swal.fire("Error", "Wishlist failed", "error");
    }
  };

  return (
    <div className="container-fluid">
      <div className="heading_common mt_10">
        <h3>Popular Products</h3>
      </div>

      <div className="popular_products_grid">
        {products.length > 0 ? (
          products.map((product) => {
            const variant = product.variants[0];
            if (!variant) return null;

            const isOutOfStock = variant.stock === 0;
            const imagePath = variant.images?.[0]?.image;

            return (
              <div key={variant.id} className="popular_products_grid_in">
                <div className="products_head d_flex justify_sp_between">
                  <span className="sale_type">Hot</span>

                  <div className="whislist_icon_box">
                    <button
                      onClick={() => toggleWishlist(variant.id)}
                      className="wishlist-btn"
                       style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                    >
                      {variant.is_wishlisted ? (
                        <FavoriteIcon style={{ color: "red" }} />
                      ) : (
                        <FavoriteBorderIcon style={{ color: "green" }} />
                      )}
                    </button>

                     <button
                            onClick={() => addToCart(variant)}
                            disabled={isOutOfStock}
                            className="add_to_cart_icons_N mt_5 wishlist-btn font_size14"
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              opacity: isOutOfStock ? 0.4 : 1,
                              pointerEvents: isOutOfStock ? "none" : "auto",
                            }}
                          >
                            <AddShoppingCartIcon style={{ color: "green" }} />
                          </button>
                  </div>
                </div>

                <div className={`products_details ${isOutOfStock ? "out-of-stock" : ""}`}>
                  <div className="products_img">
                    <Link to={`/product-details/${product.id}`}>
                      <img
                        src={imagePath || IconOne}
                        alt={product.name}
                        onError={(e) => (e.target.src = IconOne)}
                      />
                    </Link>

                    {isOutOfStock && (
                      <span className="out_of_stock_badge">
                        Out of Stock
                      </span>
                    )}
                  </div>

                  <div className="products_info">
                    <Link
                      to={`/product-details/${product.id}`}
                      className="products_name"
                    >
                      {product.name}
                    </Link>

                    <div className="pro_price mt_5 d_flex gap_10 align_center">
                      <h6>₹{variant.final_price}</h6>
                      <h6 class="price_cut"><s>₹{variant.price}</s></h6>
                    </div>

                    <div className="rating_part">
                      <span>{variant.average_rating || "0.0"}</span>
                      <StarIcon />
                    </div>
                       
                     
                      <div className="products_footer d_flex align_center justify_sp_center">
                      <Link
                        to={isOutOfStock ? "#" : `/product-details/${product.id}`}
                        className={`buy_btn font_size14 ${isOutOfStock ? "disabled-link" : ""}`}
                        onClick={(e) => {
                          if (isOutOfStock) {
                            e.preventDefault(); // stop navigation
                          }
                        }}
                        style={{
                          background: isOutOfStock ? "#f38c55" : "",
                          cursor: isOutOfStock ? "not-allowed" : "pointer",
                          pointerEvents: isOutOfStock ? "none" : "auto",
                        }}
                      >
                        {isOutOfStock ? "Out of Stock" : "Buy Now"}
                      </Link>
                    </div>


                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="container-fluid text-center pt_40 pb_40">
                <img
                  src={Watermark}
                  alt="No Products Found"
                  className="no-products-img"
                  style={{ width: "300px", opacity: 0.3 }}
                />
                <h4 className="pt_20">No Products Available</h4>
              </div>
        )}
      </div>
    </div>
  );
}

export default PopularProducts;
